import React from "react";
import PropTypes from "prop-types";

const ScrollToToaster = ({ message, onClick, onClose }) => (
  <div className="scroll_to_toaster_main">
    <div
      onClick={onClick}
      className="scroll_to_message"
    >
      <div className="inner_text">{message}</div>
    </div>

    <div
      onClick={onClose}
      className="scroll_to_close"
    >
      <div className="close_x" />
    </div>
  </div>
);

ScrollToToaster.propTypes = {
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
};

ScrollToToaster.defaultProps = {
  onClick: () => null,
  onClose: () => null,
};

ScrollToToaster.displayName = `ScrollToToaster`;

export default ScrollToToaster;
